import {hpcAttrs} from '@github-ui/hpc'

export function ImageBlob({displayName, displayUrl}: {displayName: string; displayUrl: string}) {
  return (
    <div className="d-flex flex-justify-center width-full">
      <img alt={displayName} src={displayUrl} {...hpcAttrs()} style={{maxWidth: '100%'}} />
    </div>
  )
}
